import { render, staticRenderFns } from "./ThkMaterialZhuansuEdit.vue?vue&type=template&id=c93ff230&scoped=true"
import script from "./ThkMaterialZhuansuEdit.vue?vue&type=script&lang=js"
export * from "./ThkMaterialZhuansuEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93ff230",
  null
  
)

export default component.exports